import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from "@angular/material/dialog";

export const matDialogConfig: MatDialogConfig = {
  autoFocus: false,
};

export const provideMatDialogConfig = () => {
  return {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: matDialogConfig,
  };
};
